<p-fieldset>
    <p-header class="article-title">
        <span class="article-title">{{'PACKAGE-SERVICES-LIST' | translate}}</span>
        <div class="fab-buttons">
            <!-- <div class="secondary fab-button" (click)="openServicePackageOrderDialog()" pTooltip="{{ 'NEW-SERVICE-PACKAGE-ORDER' | translate }}" tooltipPosition="bottom">
                <i class="pi pi-shopping-cart" style="font-size: 18px;"></i>
            </div> -->
            <div class="primary fab-button" (click)="openDialog(null)">
                <i class="pi pi-plus" style="font-size: 21px;"></i>
            </div>
        </div>
    </p-header>

    <div class="table">
        <p-table #tt [value]="packageServicesTable" [paginator]="true" [rows]="numberOfRows" resetPageOnSort="true"
            [pageLinks]="3" [rowsPerPageOptions]="[10,20,30,50,100]" [globalFilterFields]="['name']"
            autoLayout="true" styleClass="easy-table">
            <ng-template pTemplate="caption">
                <div class="column">
                    <p-selectButton [ngStyle]="{'float': 'left'}" [(ngModel)]="packageServiceStatus"
                        [options]="[{label: 'Todos', value: null}, {label: 'Ativo', value: true}, {label: 'Inativo', value: false}]"
                        (onChange)="tt.filter($event.value, 'active', 'equals'); changePackageServiceFilter($event.value)">
                    </p-selectButton>
                </div>

                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input type="text" pInputText size="50" placeholder="Filtro por nome" [(ngModel)]="globalFilter"
                        (input)="filterGlobal()">
                </span>

                <span style="font-weight: bold; float: right; margin-top: 5px;">{{ 'TOTAL-REGISTERS' | translate }}:
                    {{tt.totalRecords}} {{'OF' | translate}} {{packageServicesTable.length}}
                </span>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>

                    <th [pSortableColumn]="'name'">
                        Nome
                        <p-sortIcon [field]="'name'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'description'">
                        Descrição
                        <p-sortIcon [field]="'description'"></p-sortIcon>
                    </th>
                    <th class="text-center" [pSortableColumn]="'product.price'">
                        Valor
                        <p-sortIcon [field]="'product.price'"></p-sortIcon>
                    </th>
                    <th class="text-center" [pSortableColumn]="'active'">
                        Status
                        <p-sortIcon [field]="'active'"></p-sortIcon>
                    </th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-packageService>
                <tr>
                    <td>{{ packageService.name }}</td>
                    <td>{{ packageService.description ? (packageService.description.length > 150 ? packageService.description.substring(0, 150) + '...' : packageService.description) : '' }}</td>
                    <td class="text-center">{{ packageService.product?.price?.value ? 'R$ ' + packageService.product.price.value : 'Por tamanho' }}</td>
                    <td class="text-center">
                        <p-inputSwitch [(ngModel)]="packageService.active"
                                      (onChange)="toggleStatus(packageService)"
                                      [disabled]="packageService.id === 0">
                        </p-inputSwitch>
                    </td>
                    <td class="text-center">
                        <div pTooltip="Editar" (click)="edit(packageService)" tooltipPosition="bottom"
                            [disabled]="packageService.id === 0" class="table-action">
                            <i class="pi pi-pencil"></i>
                        </div>
                    </td>
                    <!-- <td class="text-center">
                        <div pTooltip="Deletar" (click)="deleteConfirm(packageService)" tooltipPosition="bottom"
                            class="table-action" [disabled]="packageService.id === 0">
                            <i class="pi pi-trash" style="color: #EF5350"></i>
                        </div>
                    </td> -->
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-fieldset>
